import {OfferType} from "./mocks/singleOfferMock";

export const OFFER_LIST_MARKER_SIZE: [number, number] = [32, 32];

export const OFFER_LIST_MARKER_BORDER_COLOR = "#000";

export const OFFER_LIST_MARKER_DOT_COLORS = {
    /** `OfferType.FLAT` (`offer.type === 1`) */
    type1: "#EE6664",
    /** `OfferType.HOUSE` (`offer.type === 2`) */
    type2: "#826AF9",
    /** Selected investment (`activeOfferId`) */
    active: "#dfff00"
} as const;

const buildOfferListMarkerDataUri = (dotColor: string): string => {
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14" height="14"><circle cy="7" cx="7" r="7" fill="${OFFER_LIST_MARKER_BORDER_COLOR}"/><circle cy="7" cx="7" r="6.5" fill="${dotColor}"/></svg>`;

    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const offerListMarkerIconUri = {
    [OfferType.FLAT]: buildOfferListMarkerDataUri(OFFER_LIST_MARKER_DOT_COLORS.type1),
    [OfferType.HOUSE]: buildOfferListMarkerDataUri(OFFER_LIST_MARKER_DOT_COLORS.type2),
    active: buildOfferListMarkerDataUri(OFFER_LIST_MARKER_DOT_COLORS.active)
};

/** Cluster bubble fill — same palette as single pins (`OfferType` from CBI `type`). */
export const offerListMarkerClusterColor = (offerType: number): string =>
    offerType === OfferType.HOUSE ? OFFER_LIST_MARKER_DOT_COLORS.type2 : OFFER_LIST_MARKER_DOT_COLORS.type1;
